import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const usePERIODIC_FORM_REPLIES_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'PERIODIC_FORM_REPLIES_CONFIG',
    name: t('widgets.periodicFormReplies.name'),
    description: t('widgets.periodicFormReplies.description'),
    color: 'blue',
    icon: 'RiBarChartFill',
    categories: [t('widgets.periodicFormReplies.category')],
    previewWidth: '100%',

    initialState: {
      size: { width: 100, height: 400 },
      data: {
        presentation: 'bar'
      }
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
